import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ This was missing

const Review = () => {
  const [selectedEmoji, setSelectedEmoji] = useState('');
  const [enjoyedMost, setEnjoyedMost] = useState('');
  const [improvement, setImprovement] = useState('');
  const [recommend, setRecommend] = useState('');

  const navigate = useNavigate(); // ✅ Needed for redirection

  const emojis = ['😟', '😐', '🙂', '😍', '🔥'];

  const handleEmojiClick = (emoji) => {
    setSelectedEmoji(emoji);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('entry.827087494', selectedEmoji);   // Emoji
    formData.append('entry.166644181', enjoyedMost);      // What did you enjoy?
    formData.append('entry.1879056877', improvement);     // Suggestions
    formData.append('entry.2132697445', recommend);       // Recommend?

    try {
      await fetch("https://docs.google.com/forms/d/e/1FAIpQLSc9zqpTEsDNECrf0gRFX5IP8zNQ9Jgz0YE9jQp2P98kaE1iVg/formResponse", {
        method: 'POST',
        mode: 'no-cors',
        body: formData,
      });

      navigate("/thank-you"); // ✅ Redirect to Thank You page
    } catch (error) {
      console.error('Error submitting feedback:', error);
      alert("Oops! Something went wrong 😓");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-[80vh] w-full px-4 py-12">
      <div className="w-full max-w-[650px] bg-white rounded-[30px] shadow-xl p-10 text-center flex flex-col gap-8">
        {/* Header */}
        <div className="flex flex-col gap-4">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#422019] font-sora">
            How would you rate your experience today?
          </h2>

          {/* Emoji Selector */}
          <div className="flex justify-center gap-4 text-[32px] sm:text-[40px] tracking-wide">
            {emojis.map((emoji, idx) => (
              <span
                key={idx}
                onClick={() => handleEmojiClick(emoji)}
                className={`cursor-pointer transition-transform duration-200 ${
                  selectedEmoji === emoji ? 'scale-125' : 'hover:scale-110'
                }`}
              >
                {emoji}
              </span>
            ))}
          </div>
        </div>

        {/* Enjoyed Most */}
        <div className="text-left">
          <label className="block text-[#422019] text-xl font-semibold mb-2">
            What did you enjoy the most?
          </label>
          <input
            type="text"
            value={enjoyedMost}
            onChange={(e) => setEnjoyedMost(e.target.value)}
            placeholder="Was there a moment that stood out? A feature you liked?"
            className="w-full px-4 py-3 rounded-xl bg-[#FDF0E3] text-[#919191] placeholder:text-[#919191] font-sora"
          />
        </div>

        {/* Improvements */}
        <div className="text-left">
          <label className="block text-[#422019] text-xl font-semibold mb-2">
            Anything we can improve?
          </label>
          <input
            type="text"
            value={improvement}
            onChange={(e) => setImprovement(e.target.value)}
            placeholder="If you could change one thing, what would it be?"
            className="w-full px-4 py-3 rounded-xl bg-[#FDF0E3] text-[#919191] placeholder:text-[#919191] font-sora"
          />
        </div>

        {/* Recommend to a Friend */}
        <div className="text-left">
          <p className="text-[#422019] text-xl font-semibold mb-4">
            Would you recommend this to a friend?
          </p>
          <div className="flex flex-col gap-3 text-left text-[#281D1B] font-sora text-lg">
            {['Yes', 'No', 'Maybe'].map((option, idx) => (
              <label key={idx} className="inline-flex items-center gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="recommend"
                  value={option}
                  checked={recommend === option}
                  onChange={(e) => setRecommend(e.target.value)}
                  className="w-5 h-5 text-orange-500 border-2 border-orange-400 rounded-full"
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        {/* Submit Button */}
        <div className="mt-4">
          <button
            onClick={handleSubmit}
            className="px-8 py-3 bg-gradient-to-br from-[#FFA502] to-[#FF6348] shadow-xl rounded-xl text-white font-bold text-lg hover:scale-105 transition"
          >
            Submit Feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default Review;
